import React, { useState, useRef } from "react";
import {
  FormControl,
  Grid,
  TextField,
  Snackbar,
  Alert as MuiAlert,
  Button,
  Typography,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Box,
  CircularProgress,
  Backdrop,
  InputAdornment,
  IconButton,
} from "@mui/material";
import Layout from "../../../layout/Layout";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { agentUser1API, config, statusAPI } from "../../../config";
import { useNavigate } from "react-router-dom";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Container } from "@mui/system";
import { useEffect } from "react";

const stateList = [
  { state_name: `Andhra Pradesh` },
  { state_name: `Andaman and Nicobar Islands` },
  { state_name: `Arunachal Pradesh` },
  { state_name: `Assam` },
  { state_name: `Bihar` },
  { state_name: `Chandigarh` },
  { state_name: `Chhattisgarh` },
  { state_name: `Dadar and Nagar Haveli` },
  { state_name: `Daman and Diu` },
  { state_name: `Delhi` },
  { state_name: `Lakshadweep` },
  { state_name: `Puducherry` },
  { state_name: `Goa` },
  { state_name: `Gujarat` },
  { state_name: `Haryana` },
  { state_name: `Himachal Pradesh` },
  { state_name: `Jammu and Kashmir` },
  { state_name: `Jharkhand` },
  { state_name: `Karnataka` },
  { state_name: `Kerala` },
  { state_name: `Madhya Pradesh` },
  { state_name: `Maharashtra` },
  { state_name: `Manipur` },
  { state_name: `Meghalaya` },
  { state_name: `Mizoram` },
  { state_name: `Nagaland` },
  { state_name: `Odisha` },
  { state_name: `Punjab` },
  { state_name: `Rajasthan` },
  { state_name: `Sikkim` },
  { state_name: `Tamil Nadu` },
  { state_name: `Telangana` },
  { state_name: `Tripura` },
  { state_name: `Uttar Pradesh` },
  { state_name: `Uttarakhand` },
  { state_name: `West Bengal` },
];

function AddUser() {
  const navigate = useNavigate();
  // const [txtUserName, setUserName] = useState("");
  // const [txtPhone, setPhone] = useState("");
  // const [txtEmail, setEmail] = useState("");
  // const [txtPassword, setPassword] = useState("");

  // const [txtName, setName] = useState("");
  // const [txtEmpNo, setEmpNo] = useState("");
  // const [txtTitle, setTitle] = useState("");
  // const [txtDepartment, setDepartment] = useState("");
  // const [txtBranch, setBranch] = useState("");
  // const [txtLocationGroup, setLocationGroup] = useState("");
  // const [txtState, setState] = useState("");
  const [departmentList, setDepartmentList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [locationGroupList, setlocationGroupList] = useState([]);
  const [txtDepartment, settxtDepartment] = useState("");
  const [txtState, settxtState] = useState("");
  const [txtLGroup, settxtLGroup] = useState("");
  const [messageType, setMessageType] = React.useState("success");
  const [message, setMessage] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [isDeptHead, setIsDeptHead] = useState(false);
  const [txtRole, settxtRole] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [txtBranch, settxtBranch] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const options = stateList.map((option) => {
    const firstLetter = option.state_name[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });
  let tempRef = useRef(false);
  useEffect(() => {
    if (tempRef.current === false) {
      let data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "35",
      });

      config.method = "patch";
      config.url = statusAPI;
      config.data = data;

      axios(config)
        .then(function (response) {
          setDepartmentList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "80",
      });

      config.data = data;

      axios(config)
        .then(function (response) {
          setBranchList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      data = JSON.stringify({
        limit: 0,
        offset: 0,
        parent_id: "82",
      });

      config.data = data;

      axios(config)
        .then(function (response) {
          setlocationGroupList(response.data["data"]);
        })
        .catch(function (error) {
          if (error.message === "Network Error") {
            localStorage.removeItem("user");
            window.location.href = window.location.origin + "/";
          }
          console.log(error);
        });

      return () => {
        tempRef.current = true;
      };
    }
  }, []);

  const validationSchema = Yup.object().shape({
    txtName: Yup.string().required("Name is required"),
    txtPhone: Yup.string().required("Phone is required"),
    txtPassword: Yup.string()
      .required("Password is required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"
      ),
    passwordConfirmation: Yup.string().oneOf(
      [Yup.ref("txtPassword"), null],
      "Passwords must match"
    ),
    txtEmail: Yup.string()
      .required("Email is required")
      .email("Please enter valid email format"),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, reset, formState, setValue } =
    useForm(formOptions);
  const { errors } = formState;

  function onSubmit(reqData) {
    setIsSubmitting(true);
    const data = JSON.stringify({
      txtUserName: reqData.txtName,
      txtPhone: reqData.txtPhone,
      txtEmail: reqData.txtEmail,
      txtPassword: reqData.txtPassword,
      txtName: reqData.txtName,
      txtEmpNo: reqData.txtEmpNo,
      txtTitle: reqData.txtTitle,
      txtDepartment: txtDepartment,
      txtBranch: txtBranch,
      txtLocationGroup: reqData.txtLocationGroup,
      txtState: reqData.txtState,
      intRole: txtRole,
      intUserID: 0,
      intSPType: 6,
      intIsDeptHead: isDeptHead ? 1 : 0,
    });
    config.method = "PATCH";
    config.data = data;
    config.url = agentUser1API;

    axios(config)
      .then(function (response) {
        setIsSubmitting(false);
        setOpen(true);
        setMessageType("success");
        if (response.data.message === "Email already exists") {
          setMessageType("warning");
          setMessage(response.data.message);
        } else if (response.data.message === "Emp No already exists") {
          setMessageType("warning");
          setMessage(response.data.message);
        } else {
          setMessage("User inserted successfully");
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setIsSubmitting(false);
      });
  }

  const handleSave = () => { };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Layout>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 9999,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
        open={isSubmitting}
      >
        <CircularProgress color="inherit" size={56} />
        <Typography variant="h6" color="inherit">
          Please wait...
        </Typography>
      </Backdrop>

      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={messageType}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <form onSubmit={handleSubmit(onSubmit)} className={`white-bg`}>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Title"
                  type="text"
                  label="Title"
                  {...register("txtTitle")}
                />
                <Typography className="invalid-feedback">
                  {errors.txtTitle?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Name"
                  type="text"
                  label="Name"
                  {...register("txtName")}
                />
                <Typography className="invalid-feedback">
                  {errors.txtName?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="EmpNo"
                  type="text"
                  label="EmpNo"
                  {...register("txtEmpNo")}
                />
                <Typography className="invalid-feedback">
                  {errors.txtEmpNo?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Phone"
                  type="text"
                  label="Phone"
                  {...register("txtPhone")}
                // value={txtPhone}
                // onChange={(e) => {
                //   setPhone(e.target.value);
                // }}
                />
                <Typography className="invalid-feedback">
                  {errors.txtPhone?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <Autocomplete
                id="department-autocomplete"
                options={departmentList}
                getOptionLabel={(option) => option.name || ""}
                value={departmentList.find(d => d.id === txtDepartment) || null}
                onChange={(event, newValue) => {
                  settxtDepartment(newValue ? newValue.id : "");
                  setValue("txtDepartment", newValue ? newValue.id : "");
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Department" variant="outlined" />
                )}
                fullWidth
              />
              <Typography className="invalid-feedback">
                {errors.txtDepartment?.message}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={6} md={6}>
              <Autocomplete
                id="branch-autocomplete"
                options={branchList}
                getOptionLabel={(option) => option.name || ""}
                value={branchList.find(b => b.id === txtBranch) || null}
                onChange={(event, newValue) => {
                  settxtBranch(newValue ? newValue.id : "");
                  setValue("txtBranch", newValue ? newValue.id : "");
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Branch" variant="outlined" />
                )}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} lg={6} md={6}>
              <Autocomplete
                id="location-group-autocomplete"
                options={locationGroupList}
                getOptionLabel={(option) => option.name || ""}
                value={locationGroupList.find(l => l.id === txtLGroup) || null}
                onChange={(event, newValue) => {
                  settxtLGroup(newValue ? newValue.id : "");
                  setValue("txtLocationGroup", newValue ? newValue.id : "");
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Location Group" variant="outlined" />
                )}
                fullWidth
              />
              <Typography className="invalid-feedback">
                {errors.txtLocationGroup?.message}
              </Typography>
            </Grid>
            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                {/* <InputLabel id="demo-simple-select-label">State</InputLabel> */}
                <Autocomplete
                  id="combo-box-demo"
                  options={options}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.state_name}
                  fullWidth
                  renderInput={(params) => (
                    <TextField {...params} label="State" variant="outlined" />
                  )}
                  onChange={(event, newValue) => {
                    console.log(newValue);
                    // setUserID(0);
                    if (newValue.state_name !== null) {
                      // setUserID(newValue.id);
                      setValue("txtState", newValue.state_name);
                    }
                  }}
                />

                {/* <Autocomplete
                  id="grouped-demo"
                  options={options.sort(
                    (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                  )}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => option.title}
                  sx={{ width: 300 }}
                  renderInput={(params) => (
                    <TextField {...params} label="State" />
                  )}
                  renderGroup={(params) => (
                    <li>
                      <GroupHeader>{params.group}</GroupHeader>
                      <GroupItems>{params.children}</GroupItems>
                    </li>
                  )}
                /> */}

                <Typography className="invalid-feedback">
                  {errors.txtState?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Email"
                  type="text"
                  label="Email"
                  {...register("txtEmail")}
                // value={txtEmail}
                // onChange={(e) => {
                //   setEmail(e.target.value);
                // }}
                />
                <Typography className="invalid-feedback">
                  {errors.txtEmail?.message}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6} md={6}>
              <Autocomplete
                id="role-autocomplete"
                options={[
                  { id: "1", name: "Super Admin" },
                  { id: "2", name: "IT Admin" },
                  { id: "3", name: "User" },
                ]}
                getOptionLabel={(option) => option.name || ""}
                value={[{ id: "1", name: "Super Admin" }, { id: "2", name: "IT Admin" }, { id: "3", name: "User" }].find(r => r.id === txtRole) || null}
                onChange={(event, newValue) => {
                  settxtRole(newValue ? newValue.id : "");
                  setValue("txtRole", newValue ? newValue.id : "");
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Role" variant="outlined" />
                )}
                fullWidth
              />
              <Typography className="invalid-feedback">
                {errors.txtRole?.message}
              </Typography>
            </Grid>
            {/* Username field removed — name is used as username */}
            {/* <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Username"
                  type="text"
                  label="Username"
                  {...register("txtUserName")}
                />
                <Typography className="invalid-feedback">
                  {errors.txtUserName?.message}
                </Typography>
              </FormControl>
            </Grid> */}
            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Password"
                  type={showPassword ? "text" : "password"}
                  label="Password"
                  autoComplete="new-password"
                  {...register("txtPassword")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          onMouseDown={(e) => e.preventDefault()}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography className="invalid-feedback">
                  {errors.txtPassword?.message}
                </Typography>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6} md={6}>
              <FormControl fullWidth>
                <TextField
                  name="Confirm Password"
                  type={showConfirmPassword ? "text" : "password"}
                  label="Confirm Password"
                  autoComplete="new-password"
                  {...register("passwordConfirmation")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle confirm password visibility"
                          onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                          }
                          onMouseDown={(e) => e.preventDefault()}
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <VisibilityOff />
                          ) : (
                            <Visibility />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography className="invalid-feedback">
                  {errors.passwordConfirmation?.message}
                </Typography>
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={12} md={12} textAlign="right">
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <Tooltip
                  title="Check this if the user is a department head"
                  arrow
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isDeptHead}
                        onChange={(e) => setIsDeptHead(e.target.checked)}
                      />
                    }
                    label="Department Head"
                  />
                </Tooltip>
                <Button
                  className={`btn-primary`}
                  type="submit"
                  disabled={isSubmitting}
                >
                  Save
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </form>
    </Layout>
  );
}

export default AddUser;
